export const v2PageBackground = 'linear-gradient(154.73deg, #08142E 0%, #1F3460 109.09%)';
